export const ratingsButtonOptions = {
	messageId: '',
	options: [],
};
